import { render, staticRenderFns } from "./CommonUploadProductModal.vue?vue&type=template&id=6bb06c42&lang=pug&"
import script from "./CommonUploadProductModal.vue?vue&type=script&lang=ts&"
export * from "./CommonUploadProductModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommonUploadProductModal.vue?vue&type=style&index=0&id=6bb06c42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports